import styled from 'styled-components';

import { TooltipNewIcon } from '@libs/components';

export const PaddingWrapper = styled.div`
  width: 100%;
  padding: 0 1.6rem;

  ${({ theme }) => theme.media.laptop`
      padding: unset;
  `}
`;

export const DetailsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: ${({ theme }) => theme.borderRadius.x3};
  border: 0.1rem solid ${({ theme }) => theme.colors.borders.default};
  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};
  padding: 1rem 1.4rem;
  width: 100%;
  height: fit-content;
  margin-top: 2.4rem;
  ${({ theme }) => theme.media.laptop`
  margin-top: 0;  
  `}
`;

export const DetailsLeftComponentWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.9rem;
`;

export const DetailsLeftComponentDescriptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;

  align-items: flex-start;
`;

export const CustomToolTipIcon = styled(TooltipNewIcon)`
  transform: rotate(180deg);
`;

export const DetailsRightComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;
